import script from "./TableHeaderModifyButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./TableHeaderModifyButton.vue?vue&type=script&lang=ts&setup=true"

import "./TableHeaderModifyButton.vue?vue&type=style&index=0&id=07bb93d2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07bb93d2"]])

export default __exports__